@import '../../../globals/main.scss';

pn-marketweb-carousel {
  display: inline-block;

  .pn-marketweb-carousel {
    .slider-wrapper {
      margin: 1rem;
      overflow: hidden;
      position: relative;
      touch-action: pan-y pinch-zoom;
    }

    .slides-container {
      display: flex;
      width: 100%;
      list-style: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
      position: relative;
      touch-action: none;
      transition: transform 0.5s ease-in-out;
      user-select: none;

      &[data-partial='false'] .slide {
        width: 100%;
      }
    }

    [data-slide] {
      flex: 0 0 auto;
      transition: transform 0.5s ease-in-out;
    }

    .nav-button {
      cursor: pointer;
      display: flex;
      position: absolute;
      top: 0;
      bottom: 0;
      transform: translateY(-50%);
      height: 2rem;
      margin: auto;
      padding: 0;
      opacity: 0.85;
      transition: opacity 200ms;
      z-index: 1;

      &.invisible {
        opacity: 0;
      }

      &[data-show='false'] {
        display: none;
      }

      &:hover,
      &:focus {
        opacity: 1;
      }
    }

    [data-nav-button-prev] {
      left: 1.75rem;
      border-radius: 0 2rem 2rem 0;
    }

    [data-nav-button-next] {
      right: 1.75rem;
      border-radius: 2rem 0 0 2rem;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .slides-container {
      transition: none;
    }

    [data-slide] {
      transition: none;
    }
  }
}
